import { IPassenger } from '../../contexts/Search/types';

/**
 * @description Checks that all passengers have a valid age.
 * @param {IPassenger[]} passengers The passengers to check.
 * @returns {boolean}
 */
export const validatePassengersAge = (passengers: IPassenger[]): boolean => {
  const res =
    passengers.length > 0 &&
    passengers.every(({ age }) => {
      return !isNaN(age) && age >= 0;
    });
  return res;
};
